import { useEffect, useRef } from 'react';
import Spinner from 'spin.js';

import { LoadingContainer, LoadingDisabler, SpinnerContainer } from './styled/components/loading';

const Loading = () => {
  const loadingSpinnerRef = useRef(null);

  useEffect(() => {
    const spinner = new Spinner({
      lines: 11,
      length: 17,
      width: 17,
      radius: 40,
      scale: 1,
      corners: 1,
      color: '#ff6600',
      opacity: 0.25,
      rotate: 0,
      direction: 1,
      speed: 1,
      trail: 60,
      fps: 20,
      zIndex: 150,
      className: 'spinner',
      top: '50%',
      left: '50%',
      shadow: false,
      hwaccel: false,
      position: 'absolute',
    });

    spinner.spin(loadingSpinnerRef.current ?? undefined);
  }, []);

  return (
    <>
      <LoadingDisabler />
      <LoadingContainer className='loading-spinner-container' data-ref='buy.loading-container'>
        <SpinnerContainer ref={loadingSpinnerRef} />
      </LoadingContainer>
    </>
  );
};

export default Loading;
